import { CommonModule } from '@angular/common';
import { ModalBaseModule } from 'Angular/features/components/modals/modal-base/modal-base.module';
import * as i0 from "@angular/core";
export class PreviewImageModalModule {
}
PreviewImageModalModule.ɵfac = function PreviewImageModalModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || PreviewImageModalModule)(); };
PreviewImageModalModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: PreviewImageModalModule });
PreviewImageModalModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule, ModalBaseModule] });
